import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { LocationService } from '../services/location.service'; 
import { inject } from '@angular/core';

export const authGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const locationService = inject(LocationService); 
  const router = inject(Router);
  if (authService.getToken() || locationService.getLocations()) {
    return true;
  }
  router.navigate(['dealer']);
  return false;
};
